import { useStackNavigate } from '@/app/navigation/stack-links';
import { DateNavigation } from '../../components/DateNavigation';

interface DayNavigationProps {
  date: string; // ISO date string
}

export function DayNavigation({ date }: DayNavigationProps) {
  const navigate = useStackNavigate();

  const handleDateChange = (newDate: string) => {
    navigate({
      to: '/day-planning/$date',
      params: { date: newDate },
    });
  };

  return <DateNavigation date={date} onChange={handleDateChange} />;
}
